import { useContext } from "react";

import { ReactQueryWrappersContext } from "../ui/ReactQueryWrappersProvider";
import type { ReactQueryWrappersContextValue } from "../models";

export const useReactQueryWrappersProvider =
  (): ReactQueryWrappersContextValue => {
    const context = useContext(ReactQueryWrappersContext);

    if (!context) {
      throw new Error(
        "useReactQueryWrappersProvider must be used within ReactQueryWrappersProvider",
      );
    }

    return context;
  };
